import { PhaseInput, StoryLevelData } from "@/app/lib/levels/story-level-data-types";

const phaseInputs: PhaseInput[] = [];

phaseInputs.push(new PhaseInput(
    [   
        'mARooN',
        'cRimSoN',
        'vERmiLioN'
    ],
    'omvci',
))

phaseInputs.push(new PhaseInput(
    [
        'lIMe',
        'eMerAlD',
        'cHArTreuSe',
    ],
    'ecrul'
))

phaseInputs.push(new PhaseInput(
    [
        'CyAn',
        'AzuRe',
        'CeRuLeAn'
    ],
    'zyune'
))

export const colors = new StoryLevelData('rgb', 'colors-0.0', phaseInputs);